import React from "react"
import Layout from "../components/Layout"
import { GatsbyImage } from "gatsby-plugin-image"
import { useStaticQuery } from "gatsby"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import SEO from "../components/SEO/Seo"

export const Head = ({ data }) => (
  <SEO
    title={data.seo.seo.metaTitle}
    description={data.seo.seo.metaDescription}
    keywords={data.seo.seo.keywords}
  />
)

const StoreLocator = ({ data }) => {

  let stores = data.allWpStore.edges

  return (
    <Layout>
      <section id="hero" className="w-full lg:h-[90vh] lg:min-h-[580px] 2xl:h-auto">
        <div className="w-full h-full grid lg:grid-cols-[607px_1fr] 1024:grid-cols-[540px_1fr]">
          <div className="bg-flavour-7 pt-3.5 lg:pb-25 1024:pb-20 pb-14 lg:px-18 1024:px-12 px-8">
            <div className="w-full inline-flex gap-2.5">
              <Link to="/">
                <span className="text-_1225 text-white opacity-50">Home /</span>
              </Link>
              <span className="text-_1225 text-white">Store Locator</span>
            </div>

            <div className="1024:mt-15 mt-11 lg:space-y-5">
              <h3 className="text-_2032 text-white font-goldplay font-bold lg:text-_2430">
                find us in the freezer aisle
              </h3>
              <h1 className="text-_4842 text-white font-gelica font-bold lg:text-_6048">
                Store Locator
              </h1>
            </div>
            <div className="max-w-[438px] lg:mt-12 mt-10">
              <p className="lg:text-_2832 1024:text-_2025 text-_2032 text-white font-gelica font-bold">
                If you're ready to simplify your kitchen experience, find us in the frozen veggie aisle of your favorite grocery store!
              </p>
            </div>
            <div className="max-w-[438px] lg:mt-16 1024:mt-8 mt-12">
              <p className="lg:text-_2025 1024:text-_1824 text-_1632 text-white font-goldplay font-semibold">
                Use the store locator below to find which locations nearest you
                stock the Dorot Gardens product range
              </p>
            </div>
          </div>
          <div className="h-full">
          <GatsbyImage
            image={data.dorotStoreLocator.childImageSharp.gatsbyImageData}
            alt="Dorot Store Locator"
            className="w-full h-full lg:object-left 2xl:object-center"
            />
          </div>
        </div>
      </section>

      <section id="store-locator" className="w-full bg-accent-purple">
        <div className="w-full flex flex-col 1024:py-14 py-8 lg:gap-x-20 lg:flex-row 2xl:limit-1440">
          <div className="2xl:w-1/2 lg:w-[47%] w-full lg:pl-18 lg:pr-0 1024:px-44 px-2.5 1024:my-0 mt-10 mb-6 order-2 1024:order-1">
            <iframe
              frameborder="0"
              scrolling="yes"
              allow="geolocation"
              id="_y83wrte82"
              src="https://wtb.bio/map/dorotgardens?embed=1&amp;src=https%3A%2F%2Fdorotgardens.com%2Fwhere-to-find%2F&amp;minH=1024"
              className="w-full overflow-hidden h-screen max-h-[690px]"
            ></iframe>
          </div>
          <div className="lg:w-1/2 w-full flex flex-col lg:justify-center lg:mt-0 1024:mt-9 1024:px-20 lg:px-0 order-1 1024:lg-order-2">
            <div className="_lg:max-w-lg 1024:max-w-3xl px-7 lg:px-0">
              <h4 className="text-_3642 text-dorot-purple font-gelica 1024:font-bold font-semibold">
                The Dorot Gardens product range is available at the following
                stores:
              </h4>
            </div>

            <div className="w-fit 1024:mt-14 mt-6 px-7 gap-5 grid lg:grid-cols-storesList_lg_mobile md:grid-cols-storesList_lg_tablet md:px-8 1024:px-0 grid-cols-storesList_mobile">
              {stores.map(store => {
                return (
                  <div className="relative overflow-hidden">
                    <GatsbyImage
                      image={store.node.featuredImage.node.gatsbyImage}
                      alt="Dorot Stores"
                    />
                  </div>
                )
              })}
            </div>

            <div className="max-w-lg mt-14 hidden lg:block">
              <p className="text-_1832 text-dorot-purple font-goldplay font-semibold">
                Don't have any of the stores above near you? Use our store
                locator to find the best place closest to you!
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default StoreLocator;

export const data = graphql`
query{
  seo: wpPage(slug: {eq: "store-locator"}) {
    seo {
      keywords
      metaDescription
      metaTitle
    }
  }
  dorotStoreLocator: file(
    relativePath: { eq: "aisle.png" }
  ) {
    childImageSharp {
      gatsbyImageData(
        formats: WEBP
        width: 1313
        placeholder: BLURRED
        quality: 100
      )
    }
  }
  allWpStore(sort: { featuredImageId: ASC }) {
    edges {
      node {
        featuredImage {
          node {
            gatsbyImage(
              placeholder: BLURRED
              formats: WEBP
              height: 157
              layout: FULL_WIDTH
            )
          }
        }
      }
    }
  }
}
`
